import { motion } from 'framer-motion/dist/framer-motion';
import React, { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { vw } from 'components/common/Common';

export const HomeMain = styled.main`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 16px;

  --home-section-padding: ${vw(240)};

  --home-section-width: calc(100vw - var(--home-section-padding));

  --home-inline-padding: 40px;
  --home-block-padding: 60px;

  --home-section-top-padding: 100px;

  @media (max-width: 938px) {
    --mb-fs-700: 24px;
  }

  @media (max-width: 757px) {
    --mb-fs-700: 16px;
    --home-inline-padding: 16px;
    --home-block-padding: 24px;
  }

  .swiper-container {
    padding: 0;
  }
`;

const StyledLink = styled(Link)`
  display: inline-block;
  padding: 8px 32px;
  border: 3px solid var(--fc-black);
  border-radius: 5vmax;
  cursor: pointer;
  font-size: var(--fs-700);
  line-height: 24px;
  font-weight: 700;
  background: #fff;
  color: var(--fc-black);
  @media (max-width: 938px) {
    color: #fff;
    background-color: var(--fc-black);
  }
  @media (max-width: 737px) {
    padding: 8px 16px;
    line-height: 19px;
  }
`;

const LinkComponent = forwardRef((props, ref) => <StyledLink ref={ref} {...props} />);
LinkComponent.displayName = 'LinkComponent';
const MotionLinkComponent = motion(LinkComponent);

const LinkContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const MoreLink = (props) => {
  return (
    <LinkContainer>
      <MotionLinkComponent
        whileHover="hover"
        variants={{
          hover: {
            color: '#fff',
            backgroundColor: 'var(--fc-black)',
            transition: { duration: 0.25 },
          },
        }}
        {...props}
      />
    </LinkContainer>
  );
};

const CirclePointer = styled(motion.div)`
  border: 3px solid #07080a;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;

  @media (max-width: 757px) {
    border: 2px solid #07080a;
    width: 32px;
    height: 32px;
  }
`;

const iconMotion = {
  hover: {
    backgroundColor: '#07080a',
    transition: {
      duration: 0.2,
      ease: 'easeIn',
    },
  },
};

export const CirclePointerIcon = (props) => {
  return (
    <CirclePointer variants={iconMotion} {...props}>
      <motion.svg
        initial={{ color: '#07080a' }}
        exit={{ color: '#07080a' }}
        variants={{
          hover: {
            color: '#fff',
            transition: {
              duration: 0.2,
              ease: 'easeIn',
            },
          },
        }}
        width="70%"
        height="70%"
        viewBox="0 0 23 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0.375 7.5L20.375 7.5" stroke="currentColor" strokeWidth="3.2" />
        <path
          d="M14.3643 13.8638L20.7282 7.49987L14.3643 1.13591"
          stroke="currentColor"
          strokeWidth="3.2"
        />
      </motion.svg>
    </CirclePointer>
  );
};

export const SectionHeaderText = styled.h2`
  font-size: 40px;
  line-height: normal;
  font-weight: 600;
  margin: 0;
  color: var(--fc-black);
  @media (max-width: 757px) {
    line-height: unset;
  }
`;

export const SectionSubHeaderText = styled.span`
  font-size: var(--fs-800);
  font-weight: 600;
  line-height: 32px;
  color: var(--fc-black);
  @media (max-width: 757px) {
    line-height: unset;
  }
`;

export const SectionHeader = styled.div`
  margin-bottom: 24px;
  @media (max-width: 757px) {
    margin-bottom: 16px;
  }
`;

export const Section = styled(motion.section)`
  max-width: 1380px;
  margin: 120px auto;
  padding: 0 var(--home-inline-padding);
  @media (max-width: 1380px) {
    margin: 60px auto;
  }

  @media (max-width: 757px) {
    margin: 40px auto;
  }
`;

export const CustomPagination = styled.div`
  display: none;
  font-weight: 700;
  font-size: var(--mb-fs-700);
  width: clamp(25px, 100%, 41px);
  @media (max-width: 757px) {
    display: block;
  }
`;
